<template>
    <div class="tip-content">
        <p v-for="text in $t('cloud_ai.feature_tip')" :key="String(text)">{{ text }}</p>
        <reo-link
            :href="config.ai_support"
            :text="$t('e2ee.learn_more')"
            target="_blank"
        />
        <div class="agreement" v-if="showAgreement">
            <ReoCheckbox
                v-model="agreement"
                :isRound="false"
            />
            <span>
                <span class="red">*</span>
                {{ $t('ai.search.dialog.agreement') }}
            </span>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { config } from '@/config/reolink';
import ReoLink from '@/basic/Link.vue';

export default Vue.extend({
    name: 'AiTipContent',
    components: {
        ReoLink
    },
    model: {
        prop: 'agreementProp',
        event: 'update:agreement'
    },
    props:{
        agreementProp:{
            type: Boolean,
            default: false
        },
        showAgreement: {
            type: Boolean,
            default: true
        }
    },
    computed:{
        config() {

            return config;

        },
        agreement:{
            get(): boolean {

                return this.agreementProp;

            },
            set( value: boolean ): void {

                this.$emit( 'update:agreement', value );

            }
        }
    }
});
</script>

<style lang="less" scoped>
.agreement{
    display: flex;
    gap: 12px;
    padding-top: 14px;
    font-size: 14px;
    line-height: 21px;
    font-weight: 500;
}
</style>
